import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetCustomerOrderById(orderId) {
  const response = await $.soap({
    body: {
      GetCustomerOrderById: {
        $xmlns: 'http://dla.mil/ems/db/order/customer_order',
        OrderID: orderId
      }
    },
    blueprint: {
      order: {
        orderId: '$..ID',
        orderFormTypeId: '$..OrderFormTypeID',
        externalUserID: '$..ExternalUserID',
        commandId: '$..CommandID',
        crsOwner: '$..CRSOwner',
        csFolderId: '$..CSFolderID',
        statusId: '$..StatusID',
        orderPackageId: '$..OrderPackageID',
        createdBy: '$..CreatedBy',
        createdOn: '$..CreatedOn',
        updatedOn: '$..UpdatedOn',
        updatedBy: '$..UpdatedBy',
        submittedOn: '$..SubmittedOn',
        submittedBy: '$..SubmittedBy',
        isClosed: '$..IsClosed',
        approvedOn: '$..ApprovedOn',
        expectedDeliveryDate: '$..ExpectedDeliveryDate',
        crsDecisionExplanation: '$..CRSDecisionExplanation',
        isNewContract: '$..IsNewContract',
        replacementPIINSPIIN: '$..ReplacementPIINSPIIN',
        numReplacementDevices: '$..NumReplacementDevices',
        popDate: '$..POPDate',
        popUpdatedBy: '$..POPDateUpdatedBy',
        popUpdatedOn: '$..POPDateUpdatedOn',
        customerContactDateReq: '$..CustomerContactDateReq',
        customerContactedOn: '$..CustomerContactedOn',
        submissionToEPCDateReq: '$..SubmissionToEPCDateReq',
        noFundingExplanation: '$..NoFundingExplanation'
      }
    }
  });

  cleanUpResponse(response);
  return response.order;
}
